<div class="static-map-container">
    <img class="map-image" [src]="mapUrl">
</div>
